import React from 'react';
import { Card } from 'react-bootstrap';

import './dashboardcard.css';

export const DashboardCard = ({ variant, cardData }) => {
  // console.log(cardData);
  const { name, total, active, inactive, lastData } = cardData
  return (
    <Card
      bg={variant.toLowerCase()}
      key={variant}
      text={variant.toLowerCase() === 'light' ? 'dark' : 'white'}
      className="mb-4 shadow"
    >
      <Card.Body>
        <Card.Title className='mb-3'>
          <h4>{name ?? "None"}</h4>
        </Card.Title>
        <Card.Text className='mb-2 text-primary'>Total Items : <b>{total ?? 0}</b></Card.Text>
        <Card.Text className='mb-2 text-success'>Active Items : <b>{active ?? 0}</b></Card.Text>
        <Card.Text className='mb-2 text-danger'>Inactive Items : <b>{inactive ?? 0}</b></Card.Text>
        <Card.Text className='text-muted'>Last Updated Item : <b>{lastData?.name ?? "Name"}</b></Card.Text>
      </Card.Body>
    </Card>
  )
}

export default DashboardCard